class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    // listen for global stock errors and show inline message if variant matches
this._onStockError = (e) => {
  try {
    const detail = e?.detail || {};
    const variantId = Number(detail.variantId);
    const message = detail.message || (detail.remaining === 0 ? 'This product is currently out of stock.' : `Only ${detail.remaining} item${detail.remaining === 1 ? '' : 's'} available. Please adjust your quantity.`);
    const currentVariantInput = this.form?.querySelector('[name="id"]');
    if (currentVariantInput && Number(currentVariantInput.value) === variantId) {
      this.showInlineError(message);
    }
  } catch (err) { console.warn('stock error handler', err); }
};
window.addEventListener('stock:error', this._onStockError);
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
  }
  // show inline error inside this product form
showInlineError(message) {
  try {
    const wrapper = this.querySelector('.product-form__error-message-wrapper');
    const messageEl = this.querySelector('.product-form__error-message');
    if (!wrapper || !messageEl) {
      console.warn('Inline error elements not found for this product form');
      return;
    }
    messageEl.textContent = message;
    wrapper.removeAttribute('hidden');
    // optional: focus the message for accessibility
    messageEl.setAttribute('tabindex', '-1');
    messageEl.focus?.();

    // auto-hide after 4 seconds
    clearTimeout(this._inlineErrorTimeout);
    this._inlineErrorTimeout = setTimeout(() => {
      wrapper.setAttribute('hidden', true);
      try { messageEl.removeAttribute('tabindex'); } catch(e){}
    }, 4000);
  } catch (e) {
    console.warn('showInlineError error', e);
  }
}

  // === Paste this as the entire body of async onSubmitHandler(evt) ===
async onSubmitHandler(evt) {
  evt.preventDefault();

  if (this._adding) return;
  this._adding = true;

  this.cartNotification?.setActiveElement(document.activeElement);

  const submitButton = this.querySelector('[type="submit"]');
  if (submitButton) {
    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');
  }

  // ensure pending map
  window.__pendingVariantAdds = window.__pendingVariantAdds || {};

  // values for finally block (do NOT re-read form there)
  let variantId = null;
  let qtyToAdd = null;
  let usedInventorySource = null; // for logs

  try {
    // --- 1) read form robustly (serializeForm OR fallback to inputs)
    let parsed = {};
    try {
      if (typeof serializeForm === 'function') parsed = JSON.parse(serializeForm(this.form));
    } catch (e) {
      parsed = {};
    }
    const idInput = this.form?.querySelector('[name="id"]');
    const qtyInput = this.form?.querySelector('[name="quantity"]');

    variantId = parsed.id ? Number(parsed.id) : (idInput ? Number(idInput.value) : null);
    qtyToAdd = parsed.quantity ? Number(parsed.quantity) : (qtyInput ? Number(qtyInput.value || 1) : 1);

    if (!variantId || Number.isNaN(variantId)) {
      console.warn('ProductForm: variant id not found — cannot enforce client-side stock guard. Allowing add.');
      variantId = null;
      qtyToAdd = qtyToAdd || 1;
    }

    console.log('ProductForm: attempt add', { variantId, qtyToAdd });

    // --- helper: try to read inventory from page Product JSON (rendered by Liquid)
    function getInventoryFromPageProductJson(vId) {
      try {
        // try several possible script id prefixes (themes vary)
        const selectors = [
          'script[type="application/json"][id^="ProductJson-"]',
          'script[type="application/json"][id^="ProductJSON-"]',
          'script[type="application/json"][id^="ProductJson"]'
        ];
        for (const sel of selectors) {
          const el = document.querySelector(sel);
          if (!el) continue;
          const p = JSON.parse(el.textContent);
          if (p && Array.isArray(p.variants)) {
            const v = p.variants.find(x => Number(x.id) === Number(vId));
            if (v && (typeof v.inventory_quantity === 'number')) {
              usedInventorySource = 'productJson';
              return Number(v.inventory_quantity);
            }
          }
        }
      } catch (e) {
        console.warn('ProductForm: getInventoryFromPageProductJson error', e);
      }
      return undefined;
    }

    // --- helper: read inventory from the DOM text (Inventory-<section.id>)
    function getInventoryFromDom() {
      try {
        // look for an element with id starting Inventory- or element with class product__inventory
        const el = document.querySelector('[id^="Inventory-"]') || document.querySelector('.product__inventory') || document.querySelector('.product__type.product__inventory');
        if (!el) return undefined;
        const txt = el.innerText || el.textContent || '';
        // extract first integer from text
        const m = txt.match(/(\d+)\b/);
        if (m) {
          usedInventorySource = 'domInventory';
          return Number(m[1]);
        }
      } catch (e) { console.warn('ProductForm: getInventoryFromDom error', e); }
      return undefined;
    }

    // --- helper: read inventory from variant endpoint
    async function getInventoryFromVariantEndpoint(vId) {
      try {
        const resp = await fetch(`/variants/${vId}.js`, { credentials: 'same-origin' });
        if (!resp.ok) {
          console.warn('ProductForm: variant endpoint returned', resp.status);
          return undefined;
        }
        const v = await resp.json();
        if (v && typeof v.inventory_quantity === 'number') {
          usedInventorySource = 'variantEndpoint';
          return Number(v.inventory_quantity);
        }
        return undefined;
      } catch (e) {
        console.warn('ProductForm: getInventoryFromVariantEndpoint error', e);
        return undefined;
      }
    }

    // --- 2) determine authoritative inventoryQuantity (try page JSON -> variant endpoint -> DOM)
    let inventoryQuantity;
    if (variantId) inventoryQuantity = getInventoryFromPageProductJson(variantId);
    if (typeof inventoryQuantity !== 'number' && variantId) inventoryQuantity = await getInventoryFromVariantEndpoint(variantId);
    if (typeof inventoryQuantity !== 'number') inventoryQuantity = getInventoryFromDom();

    console.log('ProductForm: inventoryQuantity (source)', { inventoryQuantity, usedInventorySource });

    // if inventoryQuantity is not numeric, treat as unlimited (allow)
    if (typeof inventoryQuantity !== 'number') {
      console.log('ProductForm: inventory not enforceable (allowing add)', { variantId });
    } else {
      // compute in-cart and pending
      const cartResp = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = cartResp.ok ? await cartResp.json() : { items: [] };
      const inCartQty = cart.items.reduce((s, it) => (it.variant_id === variantId ? s + it.quantity : s), 0);
      const pending = Number(window.__pendingVariantAdds[variantId] || 0);
      const remaining = Math.max(0, inventoryQuantity - inCartQty - pending);

      console.log('ProductForm: inCartQty, pending, remaining', { inCartQty, pending, remaining });

      if (remaining <= 0) {
        this.showInlineError('You cannot add more than the available inventory.');
        return;
      }
      if (qtyToAdd > remaining) {
        this.showInlineError(`Only ${remaining} item${remaining === 1 ? '' : 's'} available in stock. Please adjust your quantity.`);
        if (qtyInput) qtyInput.value = remaining;
        return;
      }
    }

    // --- 3) mark pending BEFORE sending to prevent race
    if (variantId && typeof qtyToAdd === 'number') {
      window.__pendingVariantAdds[variantId] = (window.__pendingVariantAdds[variantId] || 0) + qtyToAdd;
      console.log('ProductForm: pending increment', { variantId, pending: window.__pendingVariantAdds[variantId] });
    }

    // build body and do the add
    const bodyObj = (parsed && Object.keys(parsed).length) ? parsed : {};
    if (variantId) bodyObj.id = variantId;
    bodyObj.quantity = qtyToAdd;

    const body = JSON.stringify({
      ...bodyObj,
      sections: this.cartNotification ? this.cartNotification.getSectionsToRender().map((section) => section.id) : [],
      sections_url: window.location.pathname
    });

    const addResp = await fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body, credentials: 'same-origin' });

    if (!addResp.ok) {
      const txt = await addResp.text().catch(() => '');
      console.error('ProductForm: add-to-cart failed', addResp.status, txt);
      throw new Error('Add to cart failed');
    }

    const parsedState = await addResp.json();
    this.cartNotification?.renderContents(parsedState);
    console.log('ProductForm: add success', parsedState);

  } catch (err) {
    console.error('ProductForm error', err);
  } finally {
    // decrement pending with the exact values used above (do NOT re-read form)
    try {
      if (variantId && typeof qtyToAdd === 'number') {
        window.__pendingVariantAdds[variantId] = Math.max(0, (window.__pendingVariantAdds[variantId] || 0) - qtyToAdd);
        if (window.__pendingVariantAdds[variantId] === 0) delete window.__pendingVariantAdds[variantId];
        console.log('ProductForm: pending decrement', { variantId, pending: window.__pendingVariantAdds[variantId] || 0 });
      }
    } catch (e) {
      console.warn('ProductForm: pending decrement error', e);
    }

    if (submitButton) {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
    }
    this._adding = false;
  }
}
}

customElements.define('product-form', ProductForm);
